import { PLAN_SELECTOR_BUTTON_CLASSES } from 'pages/shop/ProductDetailPage/SecondaryInfo/FoodPreferencesSection/constants';
import twclsx from 'utils/twclsx';

/**
 * @param {Object} props
 * @param {boolean} [props.active=false] - Whether the option is currently selected
 * @param {string} props.activeLabel - Label shown when the option is selected
 * @param {import('react').ReactNode} props.children - Icon rendered beside the label
 * @param {string} [props.className] - Additional button classes
 * @param {boolean} [props.disabled=false] - Whether the button is disabled
 * @param {string} props.label - Label shown when the option is not selected
 * @param {Function} props.onClick - Click handler
 */
export function BackInStockWaitlistOptionButton({
    active = false,
    activeLabel,
    children,
    className,
    disabled = false,
    label,
    onClick,
}) {
    return (
        <button
            type="button"
            className={twclsx(PLAN_SELECTOR_BUTTON_CLASSES, 'min-w-0 grow px-10', className, {
                'border-black! bg-mango': active,
                'bg-white': !active,
            })}
            disabled={disabled}
            onClick={onClick}
            aria-current={active}
        >
            <div className="flex items-center justify-center gap-5 whitespace-nowrap">
                {children}
                <p className="font-grotesk-bold">{active ? activeLabel : label}</p>
            </div>
        </button>
    );
}
